// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SkillDisplayAndDelete.module.scss */
.SkillDisplayAndDelete_skill-display-and-delete-container__5qgG5 {
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  justify-content: space-evenly;
  overflow: scroll;
}
.SkillDisplayAndDelete_skill-display-and-delete-container__5qgG5::-webkit-scrollbar {
  display: none;
}

.SkillDisplayAndDelete_skill-display-and-delete-list__iZluh {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: block;
}

.SkillDisplayAndDelete_skill-item__Ce7Iu {
  display: inline-flex;
  margin-bottom: 5px;
  padding: 4px;
  font-size: large;
  width: -moz-fit-content;
  width: fit-content;
  list-style: none;
  transform: rotate(5deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(2n) {
  transform: rotate(-4deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(3n) {
  transform: rotate(2deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(4n) {
  transform: rotate(-5deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(5n) {
  transform: rotate(-6deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(6n) {
  transform: rotate(6deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(7n) {
  transform: rotate(-3deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(8n) {
  transform: rotate(4deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(9n) {
  transform: rotate(1deg);
}
.SkillDisplayAndDelete_skill-item__Ce7Iu:nth-child(10n) {
  transform: rotate(-1deg);
}

.SkillDisplayAndDelete_clickable-name__dPSsQ {
  font-weight: inherit;
  color: inherit;
  font-size: 1.2rem;
  cursor: pointer;
  background-color: transparent;
  padding: 0;
  border: none;
  transition: color 0.3s ease, font-size 0.3s ease; /* Add a slow transition effect */
}
.SkillDisplayAndDelete_clickable-name__dPSsQ:hover {
  color: var(--accent-color);
  font-size: 1.3rem;
}

/* Styles for highlighted skill items */
.SkillDisplayAndDelete_highlighted__JaRKJ {
  animation: SkillDisplayAndDelete_highlight-element__SkNan 5s ease;
}
@keyframes SkillDisplayAndDelete_highlight-element__SkNan {
  0% {
    padding: 0 5px;
    background-color: transparent;
    box-shadow: 0 0 0 3px transparent;
  }
  15% {
    background-color: rgb(187, 79, 187);
    box-shadow: 0 0 0 3px rgb(187, 79, 187);
  }
  20% {
    background-color: rgb(187, 79, 187);
    box-shadow: 0 0 0 3px rgb(187, 79, 187);
  }
  99% {
    padding: 0 5px;
  }
  100% {
    background-color: transparent;
    box-shadow: 0 0 0 3px transparent;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SkillDisplayAndDelete/SkillDisplayAndDelete.module.scss"],"names":[],"mappings":"AAAA,sCAAA;AAEA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;AAAJ;;AAMA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AAHF;;AAMA;EACE,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EAGA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EAEA,uBAAA;AANF;AAQE;EACI,wBAAA;AANN;AASE;EACI,uBAAA;AAPN;AAUE;EACI,wBAAA;AARN;AAWE;EACI,wBAAA;AATN;AAYE;EACI,uBAAA;AAVN;AAaE;EACI,wBAAA;AAXN;AAcE;EACI,uBAAA;AAZN;AAeE;EACI,uBAAA;AAbN;AAgBE;EACI,wBAAA;AAdN;;AAkBA;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,gDAAA,EAAA,iCAAA;AAfF;AAiBE;EACE,0BAAA;EACA,iBAAA;AAfJ;;AAmBA,uCAAA;AACA;EACE,iEAAA;AAhBF;AAmBE;EACE;IACE,cAAA;IACA,6BAAA;IACA,iCAAA;EAjBJ;EAoBE;IACE,mCAVc;IAWd,uCAAA;EAlBJ;EAqBE;IACE,mCAfc;IAgBd,uCAAA;EAnBJ;EAsBE;IACE,cAAA;EApBJ;EAuBE;IACE,6BAAA;IACA,iCAAA;IACA,UAAA;EArBJ;AACF","sourcesContent":["/* SkillDisplayAndDelete.module.scss */\n\n.skill-display-and-delete-container {\n  width: 100%; // Adjust the width as needed\n  max-height: 200px; // Fixed height for scroll\n  overflow-y: auto; // Enables vertical scrolling\n  padding: 10px;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  justify-content: space-evenly;\n  overflow: scroll;\n\n  &::-webkit-scrollbar {\n    display: none;\n}\n\n\n}\n\n.skill-display-and-delete-list {\n  list-style-type: none; // Removes bullet points\n  margin: 0;\n  padding: 0;\n  display: block; // Ensures list takes full width of the container\n}\n\n.skill-item {\n  display: inline-flex; // Items displayed one after another\n  margin-bottom: 5px; // Small margin for separation, adjust as needed\n  padding: 4px;\n  font-size: large;\n  // Add other styles for the items here\n\n  width: fit-content;\n  list-style: none;\n\n  transform: rotate(5deg);\n\n  &:nth-child(2n) {\n      transform: rotate(-4deg);\n  }\n\n  &:nth-child(3n) {\n      transform: rotate(2deg);\n  }\n\n  &:nth-child(4n) {\n      transform: rotate(-5deg);\n  }\n\n  &:nth-child(5n) {\n      transform: rotate(-6deg);\n  }\n\n  &:nth-child(6n) {\n      transform: rotate(6deg);\n  }\n\n  &:nth-child(7n) {\n      transform: rotate(-3deg);\n  }\n\n  &:nth-child(8n) {\n      transform: rotate(4deg);\n  }\n\n  &:nth-child(9n) {\n      transform: rotate(1deg);\n  }\n\n  &:nth-child(10n) {\n      transform: rotate(-1deg);\n  }\n}\n\n.clickable-name {\n  font-weight: inherit;\n  color: inherit;\n  font-size: 1.2rem;\n  cursor: pointer;\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  transition: color 0.3s ease, font-size 0.3s ease; /* Add a slow transition effect */\n\n  &:hover {\n    color: var(--accent-color);\n    font-size: 1.3rem;\n  }\n}\n\n/* Styles for highlighted skill items */\n.highlighted {\n  animation: highlight-element 5s ease;\n  $highlight-color: rgb(187, 79, 187);\n\n  @keyframes highlight-element {\n    0% {\n      padding: 0 5px;\n      background-color: transparent;\n      box-shadow: 0 0 0 3px transparent;\n    }\n\n    15% {\n      background-color: $highlight-color;\n      box-shadow: 0 0 0 3px $highlight-color;\n    }\n\n    20% {\n      background-color: $highlight-color;\n      box-shadow: 0 0 0 3px $highlight-color;\n    }\n\n    99% {\n      padding: 0 5px;\n    }\n\n    100% {\n      background-color: transparent;\n      box-shadow: 0 0 0 3px transparent;\n      padding: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skill-display-and-delete-container": `SkillDisplayAndDelete_skill-display-and-delete-container__5qgG5`,
	"skill-display-and-delete-list": `SkillDisplayAndDelete_skill-display-and-delete-list__iZluh`,
	"skill-item": `SkillDisplayAndDelete_skill-item__Ce7Iu`,
	"clickable-name": `SkillDisplayAndDelete_clickable-name__dPSsQ`,
	"highlighted": `SkillDisplayAndDelete_highlighted__JaRKJ`,
	"highlight-element": `SkillDisplayAndDelete_highlight-element__SkNan`
};
export default ___CSS_LOADER_EXPORT___;
